import { track } from '@amplitude/analytics-browser'

export const useAmplitude = () => {
  const trackEvent = (event: string, props?: Record<string, unknown>) => {
    track(event, {
      ...props,
      project: 'explorer',
    })
  }

  return { trackEvent }
}
